import Button from 'components/base/Button';
import React from 'react';
import { Props, TitleMapping } from './header.type';
import Timer from '../Timer';

const titleMapping: TitleMapping = {
  checkbox: 'Select one or more answers',
  radio: 'Select one answer'
};

function Header({
  type = 'radio',
  onNext,
  disabled,
  nextButtonLoader,
  total,
  currentStep,
  onSubmit,
  submitButtonLoader,
  endTime,
  onTimeEnd
}: Props) {
  console.log('render');

  return (
    <header className="d-flex justify-content-between align-items-center">
      <h5>{titleMapping[type]}</h5>
      {endTime && <Timer endTime={endTime} onTimeEnd={onTimeEnd} />}
      {total == currentStep ? (
        <Button
          variant="secondary"
          onClick={onSubmit}
          disabled={disabled || submitButtonLoader}
          loading={submitButtonLoader}
          loadingPosition="start"
        >
          Submit
        </Button>
      ) : (
        <Button
          variant="secondary"
          onClick={onNext}
          disabled={disabled || nextButtonLoader}
          loading={nextButtonLoader}
          loadingPosition="start"
        >
          Next question
        </Button>
      )}
    </header>
  );
}

export default Header;
